import { events } from "@planzone/events";
import { updateNotification } from "./utils/updateNotification";
import { createStateReducer } from "../utils/createStateReducer";
import { initialState } from "./initialState";

const reduceRemoveHolidayNotificationState = createStateReducer(initialState, {
  [events.removeHolidaySucceeded]: (state) => ({
    ...state,
    queue: updateNotification(
      {
        key: "removeHoliday",
        flags: ["success"],
        args: { success: "true" },
      },
      state.queue,
    ),
  }),
  [events.removeHolidayFailed]: (state) => ({
    ...state,
    queue: updateNotification(
      {
        key: "removeHoliday",
        flags: ["failure"],
        args: { failure: "true" },
      },
      state.queue,
    ),
  }),
});

export { reduceRemoveHolidayNotificationState };
